var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-md"},[_c('div',{staticClass:"my-2 p-2 inline-block rounded select-none cursor-pointer",class:_vm.customClass,on:{"click":function($event){return _vm.onClicked()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }